import type { Work } from '~/composables/api/useWorkApi'

// #681: Pyxel User Examples 投稿促進ダイアログの状態。
// クリスタル化は cradle で起き、ユーザーは完了ダイアログから魔法研究会
// (/arcaneLab) へ遷移できる。ダイアログを cradle ローカル state にすると遷移で
// 消えてしまうため、状態をグローバル store に持ち、centering43 レイアウトに
// 1 つだけマウントして cradle / arcaneLab どちらでも表示できるようにする。

// Expose store on window for E2E testing (same pattern as __dialogStore).
let _e2eExposed = false
function exposeForE2E(store: { open: (work: Work) => void, close: () => void }): void {
  if (_e2eExposed || !import.meta.client) return
  _e2eExposed = true
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ;(window as any).__pyxelSubmissionStore = {
    open: (work: Work) => store.open(work),
    close: () => store.close(),
  }
}

const _usePyxelSubmissionStore = defineStore('pyxelSubmission', () => {
  const visible = ref(false)
  const work = ref<Work | null>(null)

  const open = (target: Work): void => {
    work.value = target
    visible.value = true
  }

  const close = (): void => {
    visible.value = false
  }

  return { visible, work, open, close }
})

export function usePyxelSubmissionStore() {
  const store = _usePyxelSubmissionStore()
  exposeForE2E(store)
  return store
}
